import { useState, useEffect } from "react";
import { Divider, TextField, Typography } from "@mui/material";
import { getInputLabelProps, getInputProps } from "../../../common/appStyles";
import localize from "../../../common/localize";
import {
  getCurrencyFromSetup,
  getEventTotalValue,
} from "../../../common/EntitiesManagement";
import { getValueInCurrency } from "../../../common/utils";
import PageTitleSubtitle from "../../../components/PageTitleSubTitle";

export default function SetServiceValues({ eventModel, setEventModel }) {
  const [totalValue, setTotalValue] = useState(0);
  const handleValueChange = (input) => {
    const inputValue = parseInt(input.target.value);

    setEventModel({
      ...eventModel,
      [input.target.name]: inputValue > 0 ? inputValue : 0,
    });
  };

  useEffect(() => {
    setTotalValue(getEventTotalValue(eventModel, true));
  }, [eventModel]);

  return (
    <div style={{ width: "100%" }} className="flex flex-col gap-4 mt-2">
      <TextField
        type="number"
        InputLabelProps={getInputLabelProps()}
        inputProps={{
          ...getInputProps(),
          inputProps: {
            min: 0,
          },
        }}
        value={eventModel.executionFinalValue}
        onChange={handleValueChange}
        size="small"
        id="executionFinalValue"
        name="executionFinalValue"
        label={localize.service_value}
        variant="outlined"
        fullWidth
      />

      <TextField
        type="number"
        InputLabelProps={getInputLabelProps()}
        inputProps={{
          ...getInputProps(),
          inputProps: {
            min: 0,
          },
        }}
        value={eventModel.sparePartsFinalValue}
        onChange={handleValueChange}
        size="small"
        id="sparePartsFinalValue"
        name="sparePartsFinalValue"
        label={localize.spare_parts_value}
        variant="outlined"
        fullWidth
        minV
      />

      <PageTitleSubtitle
        useEventTitleStyle
        useFieldTitleStyle
        title={`${localize.total_value}: ${getValueInCurrency(
          getCurrencyFromSetup(),
          totalValue
        )}`}
        subtitle={`${localize.service_value} + ${localize.spare_parts_value}`}
      />

      <Divider />

      <TextField
        type="number"
        InputLabelProps={getInputLabelProps()}
        inputProps={{
          ...getInputProps(),
          inputProps: {
            min: 0,
          },
        }}
        value={eventModel.sparePartsRealValue}
        onChange={handleValueChange}
        size="small"
        id="sparePartsRealValue"
        name="sparePartsRealValue"
        label={localize.spare_parts_real_value}
        variant="outlined"
        fullWidth
        minV
      />

      <PageTitleSubtitle
        useEventTitleStyle
        useFieldTitleStyle
        title={`${localize.earning_spare_parts_value}: ${getValueInCurrency(
          getCurrencyFromSetup(),
          eventModel.sparePartsFinalValue - eventModel.sparePartsRealValue
        )}`}
        subtitle={`${localize.spare_parts_value} - ${localize.spare_parts_real_value}`}
      />
    </div>
  );
}
